import { render, staticRenderFns } from "./DetailVMInventoryOff.vue?vue&type=template&id=295c4863&scoped=true&"
import script from "./DetailVMInventoryOff.vue?vue&type=script&lang=js&"
export * from "./DetailVMInventoryOff.vue?vue&type=script&lang=js&"
import style0 from "./DetailVMInventoryOff.vue?vue&type=style&index=0&id=295c4863&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295c4863",
  null
  
)

export default component.exports